import React, { useContext} from 'react'
import Sidebar from '../components/navBar'
import classNames from 'classnames'
import { Outlet } from 'react-router-dom'
import AgentHeader from '../components/agentHeader'
import { UserContext } from "../contexts/UserContext"


const Layout = ({ hideHeader }) => {
  const {retardCall}=useContext(UserContext)
 

  return (
    <div className="h-screen w-full bg-[#F6F6F6] lg:gap-10 flex flex-col lg:flex-row">
      {!hideHeader && (
        <aside className="lg:w-64 flex-shrink-0">
          <Sidebar notification={retardCall} />
        </aside>
      )}

      <main 
        className={classNames(
          "flex-1 w-full  overflow-auto transition-all duration-300 ",
          !hideHeader ? "lg:ml-0 md:p-8" : "p-0 md:p-0" 
        )}
      >
       {!hideHeader && ( 
          <div className='text-[28px] flex justify-start ml-10 px-[24px] lg:px-0'> 
            <AgentHeader notification={retardCall}/>
          </div>
        )}
        <div className="p-0 md:p-0 min-h-full min-w-full"> 
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default Layout